"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plausibleEvent = plausibleEvent;
// Plausible reads custom events off the class list, which works only with the tagged-events script variant loaded in `components/server/plausible.tsx`
function plausibleEvent(name, props = {}) {
    // Plausible interprets spaces as separators between tags and encodes them as `+`
    const encode = (value) => String(value).trim().replace(/\s+/g, "+");
    return [`plausible-event-name=${encode(name)}`, ...Object.entries(props).map(([key, value]) => `plausible-event-${key}=${encode(value)}`)].join(" ");
}
